__turbopack_context__.v({
  "badge": "apCard-module__5vDBRW__badge",
  "card": "apCard-module__5vDBRW__card",
  "step": "apCard-module__5vDBRW__step",
  "stepCurrent": "apCard-module__5vDBRW__stepCurrent",
  "stepDone": "apCard-module__5vDBRW__stepDone",
  "steps": "apCard-module__5vDBRW__steps",
  "toolbar": "apCard-module__5vDBRW__toolbar",
});
